<div class="div-arriere-plan-action" (click)="onDismiss(false)"></div>
<div class="div-global-action"  style="text-align: center;" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div class="flex flex-column space-between gap-20" >
      <div class="flex gap-10 content-center">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(false)">
        <h3 class="bold header_title light-blue">RELANCE D'UN ASSESSEUR</h3>
      </div>

      <p class="text-md dark-blue no-margin">Vous vous apprêtez à envoyer une invitation assesseur à <span class="bold">{{assessorToRelaunch}}</span></p>

      <!-- <div class="text-container">
        <p class="text-md dark-blue no-margin">Attention, Vous pourrez relancer <span class="bold">10 fois</span> au
          maximum et à intervalle de <span class="bold">1 heure</span> minimum.</p>
      </div> -->

      <div>
        <div style="display: flex; justify-content: space-between; flex-direction: column; align-items: center;">
          <button class="action-button" (click)="onDismiss(true)">Envoyer la convocation</button>
          <p (click)=onDismiss(false) class="dark-blue pointer" style="margin-bottom: 0px;">Fermer</p>
        </div>
      </div>
    </div>
  </div>
</div>